import { render, staticRenderFns } from "./TagOptionForm.vue?vue&type=template&id=50e7fec8&"
import script from "./TagOptionForm.vue?vue&type=script&lang=ts&"
export * from "./TagOptionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports